import { useEffect, useState } from "react";
import { assetURL } from "../assets";
import { type EquipmentQuality, type EquipmentSlot, type EquipmentTier } from "../types";
import { LEGENDARY_ICON_PATHS, TIER_EQUIPMENT_ICON_PATHS } from "./gameArt";

export const SLOT_LABELS: Record<EquipmentSlot, string> = {
  weapon: "武器",
  helmet: "头盔",
  armor: "护甲",
  gloves: "手套",
  boots: "靴子",
  amulet: "护符",
};

export const QUALITY_LABELS = {
  common: "粗糙",
  uncommon: "精制",
  rare: "符刻",
  epic: "秘银",
  legendary: "传说",
} as const;

export const QUALITY_RANK: Record<EquipmentQuality, number> = {
  common: 0,
  uncommon: 1,
  rare: 2,
  epic: 3,
  legendary: 4,
};

export type InventorySort = "itemLevel" | "quality" | "newest";

export function EquipmentSlotIcon({
  slot,
  tier,
  size = 24,
  legendaryId,
  templateId,
}: {
  slot: EquipmentSlot;
  tier?: EquipmentTier;
  size?: number;
  legendaryId?: string;
  templateId?: string;
}) {
  const legendaryPath = legendaryId ? LEGENDARY_ICON_PATHS[legendaryId] : undefined;
  const templatePath =
    templateId &&
    !/_(duelist_focus|warden_rune|pilgrim_ward)$/.test(templateId) &&
    !/^t[1-5]_(weapon|helmet|armor|gloves|boots|amulet)$/.test(templateId)
      ? assetURL(`/assets/source/equipment/templates/${templateId}.png`)
      : undefined;
  const iconPaths = [
    legendaryPath,
    templatePath,
    tier ? TIER_EQUIPMENT_ICON_PATHS[tier][slot] : undefined,
  ].filter((path): path is string => Boolean(path));
  const pathKey = iconPaths.join("|");
  const [sourceIndex, setSourceIndex] = useState(0);
  useEffect(() => setSourceIndex(0), [pathKey]);
  const iconPath = iconPaths[sourceIndex];
  if (iconPath) {
    return (
      <img
        className={`equipment-item-icon${size < 32 ? " is-compact" : ""}`}
        src={iconPath}
        alt={SLOT_LABELS[slot]}
        onError={() => setSourceIndex((current) => current + 1)}
      />
    );
  }
  return (
    <span
      className={`equipment-pixel-icon equipment-pixel-${slot}${size < 32 ? " is-compact" : ""}`}
      role="img"
      aria-label={SLOT_LABELS[slot]}
    />
  );
}
